<div class="profile-wrapper">
  <div class="profile-layout">
    <p-toast></p-toast>

    <aside class="profile-sidebar">
      <div class="user-brief">
        <div class="avatar-circle">{{ user.fullname?.charAt(0) || 'U' }}</div>
        <h3>{{ user.fullname }}</h3>
        <span class="username">&#64;{{ user.username }}</span>
      </div>

      <nav class="menu-nav">
        <button class="menu-btn" [class.active]="currentView === 'profile'" (click)="setView('profile')">
          <i class="pi pi-user"></i> Mis Datos
        </button>
        <button class="menu-btn" [class.active]="currentView === 'pending'" (click)="setView('pending')">
          <i class="pi pi-wallet"></i> Pago pendiente
        </button>
        <button class="menu-btn" [class.active]="currentView === 'active'" (click)="setView('active')">
          <i class="pi pi-box"></i> Pedidos en Curso
        </button>
        <button class="menu-btn" [class.active]="currentView === 'history'" (click)="setView('history')">
          <i class="pi pi-history"></i> Historial
        </button>
      </nav>
    </aside>

    <main class="profile-content">

      <div *ngIf="currentView === 'profile'" class="fade-in">
        <div class="profile-info-card">
          <div class="card-header">
            <h2 class="section-title">Información Personal</h2>
            <button class="btn-brand-edit" (click)="openEditProfile()">
              <i class="pi pi-pencil mr-2"></i> Editar
            </button>
          </div>

          <div class="info-grid-display">
            <div class="info-item">
              <label>Nombre Completo</label>
              <p>{{ user.fullname }}</p>
            </div>
            <div class="info-item">
              <label>Usuario</label>
              <p>&#64;{{ user.username }}</p>
            </div>
            <div class="info-item">
              <label>Email</label>
              <p>{{ user.email }}</p>
            </div>
            <div class="info-item">
              <label>Fecha de Nacimiento</label>
              <p>{{ user.birthDate ? (user.birthDate | peruDate:'dd/MM/yyyy') : 'Sin registrar' }}</p>
            </div>
            <div class="info-item">
              <label>Teléfono</label>
              <p>{{ user.telephone || 'Sin registrar' }}</p>
            </div>
            <div class="info-item" style="grid-column: 1 / -1;">
              <label>Dirección de envío</label>
              <p>{{ addressLabel }}</p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="currentView === 'pending'" class="fade-in">
        <h2 class="page-title">Pago pendiente</h2>

        <div *ngIf="pendingPaymentOrders.length === 0" class="empty-state">
          <i class="pi pi-wallet"></i>
          <p>No tienes pedidos con pago pendiente.</p>
        </div>

        <div class="orders-list">
          <div *ngFor="let order of pendingPaymentOrders" class="order-card active-card-border">

            <div class="order-header-row">
              <div class="order-id-group">
                <span class="order-id">Pedido #{{ order.id }}</span>
                <span class="separator">•</span>
                <span class="order-date">{{ order.createdAt | peruDate:'d MMM, h:mm a' }}</span>
              </div>
            </div>

            <div class="order-body-row">
              <div class="status-container estado-chips">
                 <ng-container *ngIf="getOrderEstados(order).length; else pendingStatusFallback">
                   <span *ngFor="let e of getOrderEstados(order)" class="order-status-badge" [ngStyle]="getEstadoChipStyle(e)">
                     {{ e.nombreEstado }}
                   </span>
                 </ng-container>
                 <ng-template #pendingStatusFallback>
                   <span class="order-status-badge" [ngClass]="getStatusColorClass(getOrderStatusFallback(order))">
                     {{ getOrderStatusFallback(order) }}
                   </span>
                 </ng-template>
              </div>

              <div class="order-actions">
                <div class="order-total-group">
                  <span class="label">Total a Pagar</span>
                  <span class="amount">S/ {{ order.totalAmount | number:'1.2-2' }}</span>
                </div>

                <button class="btn-details-primary" [disabled]="payingOrderId === order.id" (click)="payPendingOrder(order)">
                  <i class="pi" [ngClass]="payingOrderId === order.id ? 'pi-spin pi-spinner' : 'pi-credit-card'"></i> Pagar
                </button>
                <button class="btn-details-primary" (click)="openOrderDetails(order)">
                  Ver Detalles
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="currentView === 'active'" class="fade-in">
        <h2 class="page-title">Pedidos en Curso</h2>

        <div *ngIf="activeOrders.length === 0" class="empty-state">
          <i class="pi pi-box"></i>
          <p>No tienes pedidos en curso actualmente.</p>
        </div>

        <div class="orders-list">
          <div *ngFor="let order of activeOrders" class="order-card active-card-border">

            <div class="order-header-row">
              <div class="order-id-group">
                <span class="order-id">Pedido #{{ order.id }}</span>
                <span class="separator">•</span>
                <span class="order-date">{{ order.createdAt | peruDate:'d MMM, h:mm a' }}</span>
              </div>
            </div>

            <div class="order-body-row">
              <div class="status-container estado-chips">
                 <ng-container *ngIf="getOrderEstados(order).length; else activeStatusFallback">
                   <span *ngFor="let e of getOrderEstados(order)" class="order-status-badge" [ngStyle]="getEstadoChipStyle(e)">
                     {{ e.nombreEstado }}
                   </span>
                 </ng-container>
                 <ng-template #activeStatusFallback>
                   <span class="order-status-badge" [ngClass]="getStatusColorClass(getOrderStatusFallback(order))">
                     {{ getOrderStatusFallback(order) }}
                   </span>
                 </ng-template>
              </div>

              <div class="order-actions">
                <div class="order-total-group">
                  <span class="label">Total a Pagar</span>
                  <span class="amount">S/ {{ order.totalAmount | number:'1.2-2' }}</span>
                </div>

                <button class="btn-details-primary" (click)="openOrderDetails(order)">
                  Ver Detalles
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="currentView === 'history'" class="fade-in">
        <h2 class="page-title">Historial de Compras</h2>

        <div *ngIf="historyOrders.length === 0" class="empty-state">
          <i class="pi pi-history"></i>
          <p>Aún no tienes historial.</p>
        </div>

        <div class="orders-list">
          <div *ngFor="let order of historyOrders" class="order-card history-card">

            <div class="history-header">
              <div class="history-id-group">
                <span class="history-id">#{{ order.id }}</span>
                <span class="history-date">{{ order.createdAt | peruDate:'dd MMM yyyy' }}</span>
              </div>
              <div class="estado-chips">
                <ng-container *ngIf="getOrderEstados(order).length; else historyStatusFallback">
                  <span *ngFor="let e of getOrderEstados(order)" class="order-status-badge" [ngStyle]="getEstadoChipStyle(e)">
                    {{ e.nombreEstado }}
                  </span>
                </ng-container>
                <ng-template #historyStatusFallback>
                  <span class="order-status-badge" [ngClass]="getStatusColorClass(getOrderStatusFallback(order))">
                    {{ getOrderStatusFallback(order) }}
                  </span>
                </ng-template>
              </div>
            </div>

            <div class="history-footer">
              <div class="history-price">
                S/ {{ order.totalAmount | number:'1.2-2' }}
              </div>
              <button class="btn-receipt-outline" [class.btn-receipt-pending]="!tieneBoleta(order)" [disabled]="downloadingReceiptId === order.id" [title]="tieneBoleta(order) ? 'Descargar boleta' : 'Boleta aún no emitida'" (click)="descargarRecibo(order)">
                Ver Recibo <i class="pi ml-2 text-xs" [ngClass]="downloadingReceiptId === order.id ? 'pi-spin pi-spinner' : 'pi-download'"></i>
              </button>
            </div>

          </div>
        </div>
      </div>

    </main>
  </div>
</div>

<p-dialog header="Editar mis datos" [(visible)]="showEditDialog" [modal]="true" [style]="{width: '520px'}" [draggable]="false" [resizable]="false" styleClass="custom-brand-dialog">

  <div class="form-vertical-layout">
    <div class="form-field">
      <label for="fname">Nombre Completo</label>
      <input pInputText id="fname" [(ngModel)]="userClone.fullname" class="p-inputtext-lg w-full" />
    </div>

    <div class="form-field">
      <label for="email">Correo Electrónico</label>
      <input pInputText id="email" [(ngModel)]="userClone.email" class="p-inputtext-lg w-full" />
    </div>

    <div class="form-field">
      <label for="birthDate">Fecha de Nacimiento</label>
      <input pInputText type="date" id="birthDate" [(ngModel)]="userClone.birthDate" class="p-inputtext-lg w-full" />
    </div>

    <div class="form-field">
      <label for="phone">Teléfono</label>
      <input pInputText id="phone" [(ngModel)]="userClone.telephone" class="p-inputtext-lg w-full" />
    </div>

    <div class="form-field">
      <label>País</label>
      <p-select [options]="paises" [(ngModel)]="paisId" (onChange)="onPaisChange()"
                optionLabel="nombre" optionValue="id" placeholder="País"
                [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
    </div>
    <div class="form-field">
      <label>Departamento</label>
      <p-select [options]="departamentos" [(ngModel)]="departamentoId" (onChange)="onDepartamentoChange()"
                optionLabel="nombre" optionValue="id" placeholder="Departamento"
                [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
    </div>
    <div class="form-field">
      <label>Provincia / Ciudad</label>
      <p-select [options]="provincias" [(ngModel)]="provinciaId" (onChange)="onProvinciaChange()"
                optionLabel="nombre" optionValue="id" placeholder="Provincia"
                [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
    </div>
    <div class="form-field">
      <label>Distrito</label>
      <p-select [options]="distritos" [(ngModel)]="userClone.distritoId"
                optionLabel="nombre" optionValue="id" placeholder="Distrito"
                [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
    </div>
    <div class="form-field">
      <label for="direccion">Dirección exacta</label>
      <input pInputText id="direccion" [(ngModel)]="userClone.direccion" class="p-inputtext-lg w-full"
             placeholder="Av. Principal 123..." />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-actions">
      <button pButton label="Cancelar" class="p-button-text btn-text-cancel" (click)="showEditDialog = false"></button>
      <button pButton label="Guardar Cambios" class="btn-brand-save" (click)="saveProfileChanges()"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showOrderDetailsDialog" [modal]="true" [style]="{width: '600px', maxWidth: '95vw'}" header="Detalle de Compra">
  <div *ngIf="selectedOrder" class="detail-container">
    <div class="receipt-header">
      <div class="receipt-id">Pedido #{{ selectedOrder.id }}</div>
      <div class="estado-chips">
        <ng-container *ngIf="getOrderEstados(selectedOrder).length; else detailStatusFallback">
          <span *ngFor="let e of getOrderEstados(selectedOrder)" class="order-status-badge" [ngStyle]="getEstadoChipStyle(e)">
            {{ e.nombreEstado }}
          </span>
        </ng-container>
        <ng-template #detailStatusFallback>
          <span class="order-status-badge" [ngClass]="getStatusColorClass(getOrderStatusFallback(selectedOrder))">
            {{ getOrderStatusFallback(selectedOrder) }}
          </span>
        </ng-template>
      </div>
    </div>
    <div class="receipt-items">
      <h4 class="text-sm text-gray-500 uppercase mb-2">Productos</h4>
      <div *ngFor="let item of selectedOrder.items" class="item-row">
        <div class="item-info">
          <div class="item-name">{{ item.product?.productName || item.productName }}</div>
          <div class="item-meta">Talla: {{ item.size }} <span *ngIf="item.color">| Color: {{ item.color }}</span></div>
        </div>
        <div class="item-price">
          <div class="unit-price">S/ {{ item.unitPrice }}</div>
          <div class="qty">x{{ item.quantity }}</div>
        </div>
      </div>
    </div>
    <div class="receipt-total">
      <span>Total Pagado</span>
      <span class="amount">S/ {{ selectedOrder.totalAmount | number:'1.2-2' }}</span>
    </div>
    <div class="mt-3" *ngIf="selectedOrder.paymentProof">
      <h4 class="text-sm text-gray-500 uppercase mb-2">Comprobante</h4>
      <img [src]="selectedOrder.paymentProof" style="width:100%; border-radius:8px; border:1px solid #eee;">
    </div>
  </div>
</p-dialog>
